module.exports = __webpack_public_path__ + "static/img/earthquake.2d58b3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/earthquake.png
// module id = 1O89
// module chunks = 0